import { h } from "preact";
import { useState } from "preact/hooks";
import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";
import AccessControl from "../../components/AccessControl";
import AuthControl from "../../components/AuthControl";
import ProductlaneWidget from "../../components/ProductlaneWidget";


export default function MainLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <AuthControl>
            <Layout className="layout">
                <Sidebar sidebarOpen={sidebarOpen} />
                {sidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setSidebarOpen(false)}
                    />
                )}
                <Layout>
                    <Header onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
                    <Layout.Content>
                        <AccessControl>
                            <Outlet />
                        </AccessControl>
                    </Layout.Content>
                </Layout>
            </Layout>
            {process.env.REACT_APP_SUPPORT_PORTAL_ENABLED === "true" && <ProductlaneWidget />}
        </AuthControl>
    );
}